import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "省份",
            span: 6,
            placeholder: '请输入省份',
            model: "province"
        },
        {
            label: "城市",
            span: 6,
            placeholder: '请输入城市',
            model: "city"
        },
        {
            label: "区县",
            span: 6,
            placeholder: '请输入区县',
            model: "area"
        },
        {
            label: "火车站名",
            span: 6,
            placeholder: '请输入火车站名',
            model: "name"
        },
        {
            label: "是否起点站",
            span: 6,
            labelWidth: '120px',
            placeholder: '请选择',
            type: "select",
            model: "isStartStation",
            options: dic._IS
        },
    ]
    const tableColumns = [
        {
            label: "省份",
            prop: "province",
            align: "center",
            show: true,
            name: 'province'
        },
        {
            label: "城市",
            prop: "city",
            align: "center",
            show: true,
            name: 'city'
        },
        {
            label: "区县",
            prop: "area",
            align: "center",
            show: true,
            name: 'area'
        },
        {
            label: "火车站名",
            prop: "name",
            align: "center",
            name: 'name',
            show: true
        },
        {
            label: "是否起点站",
            prop: "isStartStation",
            align: "center",
            name: 'isStartStation',
            show: true,
            formatter:(row)=>{
                return row.isStartStation == 1 ? "是": "否";
            }
        },
        {
            label: "操作",
            name: "contr",
            align: "center",
            width: '200px',
            show: true
        }
    ]
    const formItems = [
        {
            label: "火车站名",
            span: 24,
            model: "name",
            placeholder: '请输入站点名称',
            labelClass: 'info-label',
        },
        {
            label: "是否起点站",
            span: 24,
            model: "isStartStation",
            type: "select",
            labelClass: 'info-label',
            options: dic._IS
        },
    ]

    const formRules = {
        name: [{
            required: true,
            trigger: "blur",
            message: '请输入站点名称'
        }],
        isStartStation: [{
            required: true,
            trigger: "change",
            message: '请选择'
        }],
        region: [{
            required: true,
            trigger: "change",
            message: '请选择'
        }],
    }
    return {
        searchItems,
        tableColumns,
        formItems,
        formRules
    }
}
